import type {RefObject} from 'react';

/**
 * The `ArrowBackIconProps` interface defines the properties for the ArrowBackIcon component.
 */
interface ArrowBackIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "arrow_back" — outlined, weight 300.
 * Back navigation arrow icon.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const ArrowBackIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'ArrowBackIcon',
    width
}: ArrowBackIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m294.92-450 227.85 227.85L480-180 180-480l300-300 42.77 42.15L294.92-510H780v60H294.92Z" />
    </svg>
);

ArrowBackIcon.displayName = 'ArrowBackIcon';